<script>
  import loginServico from './servico';
  import radio from '~componentes/Radio.vue';

  export default {
    components: { radio },
    data() {
      return {
        usuario: {},
        tipoDocumento: 'CPF',
        documento: '',
        email:'',
        mostrarErroUsuario: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.login()
        }
      },
      login: function () {
        this.mostrarErroUsuario = false;
        this.usuario.documento = this.usuario.estrangeiro ? this.email : this.documento;
        
        $('.btn').button('loading');

        loginServico
          .aluno(this.usuario)
          .then(resposta => {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          })
          .then(() => {
            this.$router.push('/');
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
              this.usuario.dataNascimento = '';
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
          });
      },
      limparDocumento() {
        this.usuario.login = '';
        this.usuario.estrangeiro = this.tipoDocumento != "CPF";
        this.documento = '';
        this.email = '';
        this.$validator.reset();
      }
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
    },
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ tipoDocumento }} {{ !configuracao.acessoAlunoApenasCpf ? 'ou data de nascimento' : '' }} incorreto(s).</div>

      <div class="form-froup margin-bottom-10">
        <radio v-model="tipoDocumento"
               selected-value="CPF"
               type="primary"
               text-class="text-white"
               :inline="true"
               class="margin-right-10">
          Pessoa Física
        </radio>
        <radio v-model="tipoDocumento"
               selected-value="EMAIL"
               type="primary"
               :inline="true"
               text-class="text-white">
          Pessoa Física (Estrangeira)
        </radio>
      </div>

      <div class="row">
        <div class="col-sm-12" v-if="tipoDocumento=='CPF'">
          <div class="form-group required" :class="{ 'has-error': errors.has('documento') }">
            <input type="text"
                   class="form-control"
                   placeholder="CPF"
                   id="documento"
                   data-vv-name="documento"
                   data-vv-as="CPF"
                   v-model="documento"
                   v-validate="`required|cpf`"
                   v-mascara="'cpf'">

            <p class="text-danger" v-if="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" v-if="tipoDocumento=='EMAIL'">
          <div class="form-group required" :class="{'has-error': errors.has('email')}">
            <input type="text"
                    class="form-control"
                    placeholder="Email"
                    id="email"
                    data-vv-name="email"
                    data-vv-as="email"
                    v-model="email"
                    v-validate="`required|email`">

            <p class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" :class="{ 'has-error': errors.has('dataNascimento') }" v-if="!configuracao.acessoAlunoApenasCpf">
            <input type="text"
                    class="form-control"
                    placeholder="Data de nascimento"
                    v-model="usuario.dataNascimento"
                    v-validate="`required|date_format:DD/MM/YYYY`"
                    id="data-nascimento"
                    data-vv-name="dataNascimento"
                    data-vv-as="data de nascimento"
                    v-mascara="'data'">

            <p class="text-danger" v-if="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <button type="submit"
                  class="btn btn-primary block full-width m-b"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
            Entrar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginAluno.vue